module.exports = __webpack_public_path__ + "static/media/lpr.4b9d7079.svg";